var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exchange_user"},[_c('h3',[_vm._v("신청자")]),_vm._m(0),_c('dl',[_c('dt',[_vm._v("이름")]),_c('dd',[_vm._v(_vm._s(_vm.exchangeInit.userName))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("사업자 유형​")]),_c('dd',[_vm._v("개인​")])])
}]

export { render, staticRenderFns }